import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ConfirmDialog,
  MefEfileChangesComponent,
} from './components/mef-efile-changes/mef-efile-changes.component';
import { AppNgAppkitModule } from '../app-ng-appkit.module';
import { AppNgMaterialModule } from '../app-ng-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AdminService } from './admin.service';
import { AdminBreadcrumbService } from './shared/admin-breadcrumb.service';
import { NaicsMaintenanceComponent } from './components/naics-maintenance/naics-maintenance.component';
import { EntityChartMapCleanUpComponent } from './components/entity-chart-map-clean-up/entity-chart-map-clean-up.component';
import { S3FileUpload } from './components/s3-file-upload/s3-file-upload.component';
import { SharedComponentsModule } from '../shared/components/shared-components.module';
import { DfMappingChangesComponent } from './components/df-mapping-changes/df-mapping-changes.component';
import { S3FolderManagerComponent } from './components/s3-folder-manager/s3-folder-manager.component';
import { PostingPartnersComponent } from './components/posting-partners/posting-partners.component';
import { UserAccessRequestComponent } from './components/user-access-request/user-access-request.component';
import { UserAccessApprovalComponent } from './components/user-access-approval/user-access-approval.component';
import { TemplateAssignRequestApprovalComponent } from './components/user-access-approval/template-assign-request-approval/template-assign-request-approval.component';
import { BusinessAssignRequestApprovalComponent } from './components/user-access-approval/business-assign-request-approval/business-assign-request-approval.component';
import { RejectUserRequestComponent } from './components/user-access-approval/reject-user-request/reject-user-request.component';
import { ViewRequestHistoryComponent } from './components/user-access-approval/view-request-history/view-request-history.component';
import { UsersComponentModule } from '../users-component/users-component.module';
import { UsersComponentComponent } from '../users-component/users-component.component';
import { UserOnboardingComponent } from './components/user-onboarding/user-onboarding.component';
import { ConsolGroupComponent } from './components/consol-group/consol-group.component';
import { BatchMonitoringComponent } from './components/batch-monitoring/batch-monitoring.component';
import { AggregrationRerunComponent } from './components/aggregration-rerun/aggregration-rerun.component';
import { UpdateChangeListComponent } from './components/update-change-list/update-change-list.component';
import { UpdateDocumentDetailComponent } from './components/update-document-detail/update-document-detail.component';
import { BatchRequestComponent } from './components/batch-request/batch-request.component';
import { BasketPostComponent } from './components/basket-post/basket-post.component';
import { BasketPostDeleteComponent } from './components/basket-post-delete/basket-post-delete.component';
import { MaintenanceOwnerComponent } from './components/maintenance-owner/maintenance-owner.component';
import { MaintenanceOwnerDeleteComponent } from './components/maintenance-owner-delete/maintenance-owner-delete.component';
import { AmendedCycleComponent } from './components/amended-cycle/amended-cycle.component';
import { AdminScenarioSetupComponent } from './components/admin-scenario-setup/admin-scenario-setup.component';
import { TblMaintenanceComponent } from './components/tbl-maintenance/tbl-maintenance.component';
import { DeltaPostingComponent } from './components/delta-posting/delta-posting.component';
import { PdfFormOrderComponent } from './components/pdf-form-order/pdf-form-order.component';
import { IssueAddComponent } from './components/issue-management/issue-add.component';
import { IssueEditComponent } from './components/issue-management/issue-edit.component';
import { IssueManagementListComponent } from './components/issue-management-list/issue-management-list.component';
import { IssueManagementService } from './components/issue-management/issue-management.service';
import { SharedDirectivesModule } from '../shared/_directives/shared-directives.module';
import { EntityUpdateComponent } from './components/entity-update/entity-update.component';
import { SecondaryActionDashboardComponent } from './components/secondary-action-dashboard/secondary-action-dashboard.component';
import { AdminActionsComponent } from './components/admin-actions/admin-actions.component';
import { AdminActionEditComponent } from './components/admin-actions/admin-action-edit.component';
import { AdminActionsService } from './components/admin-actions/admin-actions.service';
import { AdminJobConsoleListComponent } from './components/admin-job-console-list/admin-job-console-list.component';
import { AdminJobConsoleEditComponent } from './components/admin-job-console-list/admin-job-console-edit/admin-job-console-edit.component';
import { AdminJobConsoleService } from './components/admin-job-console-list/admin-job-console.service';
import { AdminValidationRuleEditComponent } from './components/admin-validation-rule-edit/admin-validation-rule-edit.component';
import { AdminRulesEngineSuppDetailsComponent } from './components/admin-rules-engine-supp-details/admin-rules-engine-supp-details.component';
import { ChangeLogJobRunDetailsComponent } from './components/change-log-job-run-details/change-log-job-run-details.component';
import { AdminResetDsConnectionComponent } from './components/admin-reset-ds-connection/admin-reset-ds-connection.component';
import { AdminUsersComponent } from './components/admin-users/admin-users.component';
import { AddUserModalComponent } from './components/admin-users/add-user-modal/add-user-modal.component';
import { AccessRenewalComponent } from './components/access-renewal/access-renewal.component';
import { UserExpiryReportModalComponent } from './components/access-renewal/user-expiry-report-modal/user-expiry-report-modal.component';
import { AccessRenewalService } from './components/access-renewal/access-renewal.service';
import { UsersAccessReportComponent } from './components/users-access-report/users-access-report.component';
import { GridBuilderComponent } from './components/grid-builder/grid-builder.component';
import { GridBuilderEditComponent } from './components/grid-builder/grid-builder-edit.component';
import { BatchActionEditComponent } from './components/grid-builder/batch-action-edit.component';
import { MasterDataComponent } from './components/master-data/master-data.component';
import { SystemMappingComponent } from './components/master-data/system-mapping/system-mapping.component';
import { CreateSystemAccountModalComponent } from './components/master-data/system-mapping/create-system-account-modal/create-system-account-modal.component';
import { EditSystemAccountModalComponent } from './components/master-data/system-mapping/edit-system-account-modal/edit-system-account-modal.component';
import { CacheControlComponent } from './components/cache-control/cache-control.component';
import { TemplatesComponent } from './components/templates/templates.component';
import { TemplateTypeEditComponent } from './components/templates/template-type-edit/template-type-edit.component';
import { TemplateEditComponent } from './components/templates/template-edit/template-edit.component';
import { AdminFiltersComponent } from './components/admin-filters/admin-filters.component';
import { AdminFilterEditComponent } from './components/admin-filters/admin-filter-edit.component';
import { RulesEngineComponent } from './components/rules-engine/rules-engine.component';
import { ValidationRuleEditModalComponent } from './components/rules-engine/validation-rule-edit-modal/validation-rule-edit-modal.component';
import { ChartRolloverMaintenanceComponent } from './components/chart-rollover-maintenance/chart-rollover-maintenance.component';
import { NotifEngineComponent } from './components/notif-engine/notif-engine.component';
import { ProcessMapComponent } from './components/process-map/process-map.component';
import { TemplateAssignComponent } from './components/template-assign/template-assign.component';
import { ClientComponent } from './components/client/client.component';
import { ClientSaveModalComponent } from './components/client-save-modal/client-save-modal.component';
import { WorkflowAddModalComponent } from './components/workflow-add-modal/workflow-add-modal.component';
import { WorkflowEditModalComponent } from './components/workflow-edit-modal/workflow-edit-modal.component';
import { JdcManagerComponent } from './components/jdc-manager/jdc-manager.component';
import { JdcActivityUserListModalComponent } from './components/jdc-manager/jdc-activity-user-list-modal/jdc-activity-user-list-modal.component';
import { JdcTasksReorderModalComponent } from './components/jdc-manager/jdc-tasks-reorder-modal/jdc-tasks-reorder-modal.component';
import { JdcCopyRolesAccessModalComponent } from './components/jdc-manager/jdc-copy-roles-access-modal/jdc-copy-roles-access-modal.component';
import { JdcChannelModalComponent } from './components/jdc-manager/jdc-channel-modal/jdc-channel-modal.component';
import { JdcAssignTemplatesModalComponent } from './components/jdc-manager/jdc-assign-templates-modal/jdc-assign-templates-modal.component';
import { JdcNewKeyModalComponent } from './components/jdc-manager/jdc-new-key-modal/jdc-new-key-modal.component';
import { JdcSaveActivityModalComponent } from './components/jdc-manager/jdc-save-activity-modal/jdc-save-activity-modal.component';
import { JdcSaveTaskModalComponent } from './components/jdc-manager/jdc-save-task-modal/jdc-save-task-modal.component';
import { GoldSyncComponent } from './components/gold-sync/gold-sync.component';
import { GoldSyncTableDetailsDialogComponent } from './components/gold-sync/gold-sync-table-details-dialog/gold-sync-table-details-dialog.component';
import { GoldSyncCronHelpDialogComponent } from './components/gold-sync/gold-sync-cron-help-dialog/gold-sync-cron-help-dialog.component';
import { AdminDashboardsComponent } from './components/admin-dashboards/admin-dashboards.component';
import { AdminDashboardEditComponent } from './components/admin-dashboards/admin-dashboard-edit/admin-dashboard-edit.component';
import { NotificationComponent } from './components/notification/notification.component';
import { NotificationPayloadModalComponent } from './components/notification/notification-payload-modal/notification-payload-modal.component';
import { ScreensComponent } from './components/screens/screens.component';
import { ScreenEditComponent } from './components/screens/screen-edit.component';
import { AuditEngineComponent } from './components/audit-engine/audit-engine.component';
import { BizzHierComponent } from './components/bizz-hier/bizz-hier.component';
import { BizzHierViewComponent } from './components/bizz-hier-view/bizz-hier-view.component';
import { WorkspaceComponent } from './components/workspace/workspace.component';
import { EntityMgmtAppComponent } from './components/entity-mgmt-app/entity-mgmt-app.component';
import { ControversyAppComponent } from './components/controversy-app/controversy-app.component';
import { DashboardExecutiveComponent } from './components/dashboard-executive/dashboard-executive.component';
import { FormViewComponent } from './components/form-view/form-view.component';
import { BulkExportComponent } from './components/form-view/bulk-export/bulk-export.component';
import { ReviewDiagnosticsComponent } from './components/form-view/review-diagnostics/review-diagnostics.component';
import { S3TemplateViewComponent } from './components/form-view/s3-template-view/s3-template-view.component';
import { DrilldownGridComponent } from './components/form-view/drilldown-grid/drilldown-grid.component';
import { FormViewTabComponent } from './components/form-view/form-view-tab/form-view-tab.component';
import { ViewBulkExportSelectionComponent } from './components/form-view/view-bulk-export-selection/view-bulk-export-selection.component';
import { EntityChartMapComponent } from './components/entity-chart-map/entity-chart-map.component';
import { AlertsComponent } from './components/alerts/alerts.component';
import { EmailSettingsComponent } from './components/email-settings/email-settings.component';
import { AggregationTriggerComponent } from './components/aggregation-trigger/aggregation-trigger.component';
import { SystemMessageComponent } from './components/system-message/system-message.component';
import { SwitchUserComponent } from './components/switch-user/switch-user.component';
import { CreateNewSettingsComponent } from './components/create-new-settings/create-new-settings.component';
import { SystemSettingsComponent } from './components/system-settings/system-settings.component';
import { SwitchUserModalComponent } from './components/system-settings/switch-user-modal/switch-user-modal.component';
import { CreateSettingsModalComponent } from './components/system-settings/create-settings-modal/create-settings-modal.component';
import { HelpComponent } from './components/help/help.component';
import { OrgChartComponent } from './components/org-chart/org-chart.component';
import { SettingsComponent } from './components/settings/settings.component';
import { ClientLandingPageComponent } from './components/client-landing-page/client-landing-page.component';
import { ClientDetailsModalComponent } from './components/client-landing-page/client-details-modal/client-details-modal.component';
import { DataFiltersComponent } from './components/data-filters/data-filters.component';
import { TaxSensitiveAcctComponent } from './components/tax-sensitive-acct/tax-sensitive-acct.component';
import { TaxCycleWorkflowComponent } from './components/tax-cycle-workflow/tax-cycle-workflow.component';
import { AdminRoutingModule } from './admin-routing.module';
import { AdminShellComponent } from './admin-shell.component';
import { AdminGridDirective } from './shared/admin-grid.directive';

@NgModule({
  declarations: [
    AdminShellComponent,
    AdminGridDirective,
    MefEfileChangesComponent,
    ConfirmDialog,
    NaicsMaintenanceComponent,
    EntityChartMapCleanUpComponent,
    S3FileUpload,
    DfMappingChangesComponent,
    S3FolderManagerComponent,
    PostingPartnersComponent,
    UserAccessRequestComponent,
    UserAccessApprovalComponent,
    TemplateAssignRequestApprovalComponent,
    BusinessAssignRequestApprovalComponent,
    RejectUserRequestComponent,
    ViewRequestHistoryComponent,
    UserOnboardingComponent,
    ConsolGroupComponent,
    BatchMonitoringComponent,
    AggregrationRerunComponent,
    UpdateChangeListComponent,
    UpdateDocumentDetailComponent,
    BatchRequestComponent,
    BasketPostComponent,
    BasketPostDeleteComponent,
    MaintenanceOwnerComponent,
    MaintenanceOwnerDeleteComponent,
    AmendedCycleComponent,
    AdminScenarioSetupComponent,
    TblMaintenanceComponent,
    PdfFormOrderComponent,
    DeltaPostingComponent,
    IssueAddComponent,
    IssueEditComponent,
    IssueManagementListComponent,
    EntityUpdateComponent,
    SecondaryActionDashboardComponent,
    AdminActionsComponent,
    AdminActionEditComponent,
    AdminJobConsoleListComponent,
    AdminJobConsoleEditComponent,
    AdminValidationRuleEditComponent,
    AdminRulesEngineSuppDetailsComponent,
    ChangeLogJobRunDetailsComponent,
    AdminResetDsConnectionComponent,
    AdminUsersComponent,
    AddUserModalComponent,
    AccessRenewalComponent,
    UserExpiryReportModalComponent,
    UsersAccessReportComponent,
    GridBuilderComponent,
    GridBuilderEditComponent,
    BatchActionEditComponent,
    MasterDataComponent,
    SystemMappingComponent,
    CreateSystemAccountModalComponent,
    EditSystemAccountModalComponent,
    CacheControlComponent,
    TemplatesComponent,
    TemplateTypeEditComponent,
    TemplateEditComponent,
    AdminFiltersComponent,
    AdminFilterEditComponent,
    RulesEngineComponent,
    ValidationRuleEditModalComponent,
    ChartRolloverMaintenanceComponent,
    NotifEngineComponent,
    ProcessMapComponent,
    TemplateAssignComponent,
    ClientComponent,
    ClientSaveModalComponent,
    WorkflowAddModalComponent,
    WorkflowEditModalComponent,
    JdcManagerComponent,
    JdcActivityUserListModalComponent,
    JdcTasksReorderModalComponent,
    JdcCopyRolesAccessModalComponent,
    JdcChannelModalComponent,
    JdcAssignTemplatesModalComponent,
    JdcNewKeyModalComponent,
    JdcSaveActivityModalComponent,
    JdcSaveTaskModalComponent,
    GoldSyncComponent,
    GoldSyncTableDetailsDialogComponent,
    GoldSyncCronHelpDialogComponent,
    AdminDashboardsComponent,
    AdminDashboardEditComponent,
    NotificationComponent,
    NotificationPayloadModalComponent,
    ScreensComponent,
    ScreenEditComponent,
    AuditEngineComponent,
    BizzHierComponent,
    BizzHierViewComponent,
    WorkspaceComponent,
    EntityMgmtAppComponent,
    ControversyAppComponent,
    DashboardExecutiveComponent,
    FormViewComponent,
    FormViewTabComponent,
    BulkExportComponent,
    ReviewDiagnosticsComponent,
    S3TemplateViewComponent,
    DrilldownGridComponent,
    ViewBulkExportSelectionComponent,
    EntityChartMapComponent,
    AlertsComponent,
    EmailSettingsComponent,
    AggregationTriggerComponent,
    SystemMessageComponent,
    SwitchUserComponent,
    CreateNewSettingsComponent,
    SystemSettingsComponent,
    SwitchUserModalComponent,
    CreateSettingsModalComponent,
    HelpComponent,
    OrgChartComponent,
    SettingsComponent,
    ClientLandingPageComponent,
    ClientDetailsModalComponent,
    DataFiltersComponent,
    TaxSensitiveAcctComponent,
    TaxCycleWorkflowComponent,
  ],

  imports: [
    CommonModule,
    AppNgAppkitModule,
    AppNgMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SharedComponentsModule,
    SharedDirectivesModule,
    UsersComponentModule,
    AdminRoutingModule,
  ],
  exports: [
    AdminGridDirective,
    MefEfileChangesComponent,
    ConfirmDialog,
    NaicsMaintenanceComponent,
    S3FileUpload,
    DfMappingChangesComponent,
    S3FolderManagerComponent,
    ConsolGroupComponent,
    BatchMonitoringComponent,
    AggregrationRerunComponent,
    UpdateChangeListComponent,
    UpdateDocumentDetailComponent,
    BatchRequestComponent,
    BasketPostComponent,
    BasketPostDeleteComponent,
    MaintenanceOwnerComponent,
    MaintenanceOwnerDeleteComponent,
    AmendedCycleComponent,
    AdminScenarioSetupComponent,
    TblMaintenanceComponent,
    PdfFormOrderComponent,
    DeltaPostingComponent,
    IssueAddComponent,
    IssueEditComponent,
    IssueManagementListComponent,
    EntityUpdateComponent,
    SecondaryActionDashboardComponent,
    AdminActionsComponent,
    AdminActionEditComponent,
    NotifEngineComponent,
    ProcessMapComponent,
    TemplateAssignComponent,
    ClientComponent,
    ClientSaveModalComponent,
    JdcManagerComponent,
    GoldSyncComponent,
    AdminDashboardsComponent,
    NotificationComponent,
    ScreensComponent,
    ScreenEditComponent,
    AuditEngineComponent,
    AccessRenewalComponent,
    UsersAccessReportComponent,
    BizzHierComponent,
    BizzHierViewComponent,
    WorkspaceComponent,
    EntityMgmtAppComponent,
    ControversyAppComponent,
    DashboardExecutiveComponent,
    FormViewComponent,
    FormViewTabComponent,
    BulkExportComponent,
    ReviewDiagnosticsComponent,
    S3TemplateViewComponent,
    DrilldownGridComponent,
    ViewBulkExportSelectionComponent,
    EntityChartMapComponent,
    AlertsComponent,
    EmailSettingsComponent,
    AggregationTriggerComponent,
    SystemMessageComponent,
    SwitchUserComponent,
    CreateNewSettingsComponent,
    SystemSettingsComponent,
    HelpComponent,
    OrgChartComponent,
    SettingsComponent,
    ClientLandingPageComponent,
    ClientDetailsModalComponent,
    DataFiltersComponent,
    TaxSensitiveAcctComponent,
    TaxCycleWorkflowComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    AdminService,
    IssueManagementService,
    AdminActionsService,
    AdminJobConsoleService,
    AccessRenewalService,
    AdminBreadcrumbService,
  ],
})
export class AdminModule {}
